import api, { BodyData } from '../../../../utils/api';

export interface SendRejectionEmailPayload extends BodyData {
    emailSignature: string;
    rejectionEmailTitle: string;
    dutchRejectionEmailContent: string;
    englishRejectionEmailContent: string;
}

const sendTestRejectionEmail = async (payload: SendRejectionEmailPayload): Promise<unknown> => {
    return await api.post('api/agency/mailing/send-test-rejection-email', payload);
}

export default sendTestRejectionEmail;
